export interface AILogoProps {
  className?: string
  ariaLabel?: string
  /** Render in brand color rather than currentColor. Default false. */
  brand?: boolean
}

/**
 * Perplexity mark.
 * SVG sourced from the in-app Bot tracking icon library so the homepage
 * matches the real app.
 */
export default function PerplexityLogo({
  className,
  ariaLabel = 'Perplexity',
  brand = false,
}: AILogoProps) {
  const fill = brand ? '#20808D' : 'currentColor'
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      role="img"
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M22.3977 7.0896h-2.3106V0.0676l-7.5094 6.3542V0.1577h-1.1554v6.1966L4.4904 0v7.0896H1.6023v10.3976h2.8882V24l6.932 -6.3591v6.2005h1.1554v-6.0469l6.9318 6.1807v-6.4879h2.8882V7.0896zm-3.4657 -4.531v4.531h-5.355l5.355 -4.531zm-13.2862 0.0676 4.8691 4.4634H5.6458V2.6262zM2.7576 16.332V8.245h7.8476l-6.1149 6.1147v1.9723H2.7576zm2.8882 5.0404v-3.8852h0.0001v-2.6488l5.7763 -5.7764v7.0111l-5.7764 5.2993zm12.7086 0.0248 -5.7766 -5.1509V9.0618l5.7766 5.7766v6.5588zm2.8882 -5.0652h-1.733v-1.9723L13.3948 8.245h7.8478v8.087z"
      />
    </svg>
  )
}
